<template>
   <div class="chart-btn">
      <!-- ctas -->
      <a
         class="btn btn-primary-grad chart-btn--grad-custom"
         :href="getDownloadBtnProps.link"
         @click.prevent="goTo(getDownloadBtnProps.link)"
         v-text="getDownloadBtnProps.text"
      />

      <a
         class="btn btn-outline-primary m-0 chart-btn--primary-custom"
         :href="getSecondaryBtnProps.link"
         target="_blank"
         rel="noopener noreferrer"
         v-text="getSecondaryBtnProps.text"
      >
      </a>
   </div>
</template>

<script>
export default {
   name: 'ChartButtons',
   props: {
      getStartedCtas: {
         type: Array,
         default: () => [],
      },

      framework: {
         type: String,
         default: 'js',
      },
   },
   data() {
      return {
         ctaButtonText: '',
         ctaButtonLink: '',
         frameworkList: {
            js: {
               name: 'Javascript',
               link:
                  'https://www.fusioncharts.com/dev/getting-started/plain-javascript/your-first-chart-using-plain-javascript',
            },
            react: {
               name: 'React',
               link:
                  'https://www.fusioncharts.com/dev/getting-started/react/your-first-chart-using-react',
            },
            angular4: {
               name: 'Angular 4',
               link:
                  'https://www.fusioncharts.com/dev/getting-started/angular/angular/your-first-chart-using-angular',
            },
            jquery: {
               name: 'jQuery',
               link:
                  'https://www.fusioncharts.com/dev/getting-started/jquery/your-first-chart-using-jquery',
            },
            vue: {
               name: 'Vue',
               link:
                  'https://www.fusioncharts.com/dev/getting-started/vue/your-first-chart-using-vuejs',
            },
            ember: {
               name: 'Ember',
               link:
                  'https://www.fusioncharts.com/dev/getting-started/ember/your-first-chart-using-ember',
            },
            'react-native': {
               name: 'React Native',
               link:
                  'https://www.fusioncharts.com/dev/getting-started/react-native/your-first-chart-using-react-native',
            },
            angular: {
               name: 'Angular',
               link:
                  'https://www.fusioncharts.com/dev/getting-started/angular/angularjs/your-first-chart-using-angularjs',
            },
            php: {
               name: 'php',
               link:
                  'https://www.fusioncharts.com/dev/getting-started/php/your-first-chart-using-php',
            },
            rails: {
               name: 'Rails',
               link:
                  'https://www.fusioncharts.com/dev/getting-started/ruby-on-rails/your-first-chart-using-ruby-on-rails',
            },
            csharp: {
               name: 'Csharp',
               link:
                  'https://www.fusioncharts.com/dev/getting-started/aspnet/your-first-chart-using-aspnet',
            },
            vb: {
               name: 'Vb',
               link:
                  'https://www.fusioncharts.com/dev/getting-started/aspnet/your-first-chart-using-aspnet',
            },
            python: {
               name: 'Python',
               link:
                  'https://www.fusioncharts.com/dev/getting-started/django/your-first-chart-using-django',
            },
            java: {
               name: 'Java',
               link:
                  'https://www.fusioncharts.com/dev/getting-started/java/your-first-chart-using-java',
            },
         },
      };
   },

   computed: {
      getDownloadBtnProps() {
         const link =
            (this.getStartedCtas.length > 0 &&
               this.getStartedCtas[0] &&
               this.getStartedCtas[0].link) ||
            `/download?framework=${this.framework}`;
         const text =
            (this.getStartedCtas.length &&
               this.getStartedCtas[0] &&
               this.getStartedCtas[0].header) ||
            'DOWNLOAD TRIAL';
         return { link, text };
      },

      getSecondaryBtnProps() {
         const link =
            this.getStartedCtas.length > 1 ? this.getStartedCtas[1].link : this.getDefaultDocLink;
         const text =
            (this.getStartedCtas.length &&
               this.getStartedCtas[1] &&
               this.getStartedCtas[1].header) ||
            `EXPLORE ${(this.framework || this.currentFramework).toUpperCase()} DOCUMENTATION`;
         return { text, link };
      },

      getDefaultDocLink() {
         const item = this.frameworkList[this.framework || this.currentFramework];
         return item ? item.link : this.frameworkList.js.link;
      },
   },

   created() {
      const queryFramework = this.$route.query.framework;
      this.currentFramework = queryFramework || 'javascript';
   },

   methods: {
      goTo(link) {
         this.$router.push(link).catch(() => {});
      },
   },
};
</script>

<style lang="scss" scoped>
.chart-btn {
   &--grad-custom,
   &--primary-custom {
      padding: 13px 24px;
      font-size: 15px;
      margin-right: 18px;
      line-height: 16px;
      &:hover {
         box-shadow: 0 4px 6px 0 rgba(50, 50, 93, 0.11);
      }
   }
   &--primary-custom {
      padding: 11.99px 24px;
      @media (max-width: 350px) {
         padding: 11.99px 15px;
      }
   }
   &--grad-custom {
      @media (max-width: 483px) {
         margin-bottom: 18px;
      }
   }
}
</style>
